import "./ferrosilicon.scss";
import { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { Helmet } from "react-helmet";


export default function Ferrosilicon() {
    const img = [
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731594275/ferrosilicon3_cvegww.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731594275/ferrosilicon2_ymaebz.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731594277/ferrosilicon4_ezx6l9.jpg",
        "https://res.cloudinary.com/dobxtcf1w/image/upload/v1731594276/ferrosilicon1_eptdgd.jpg"
    ]
    const [currentImg, setCurrentImg] = useState(0)
  return (

    <div className='main_wrapper'>
        <Helmet>
        <title>FerroSilicon || Raydron, Lagos, Nigeria</title>
        <meta name="description" content="Ferro silicon is an alloy made primarily of iron (Fe) and silicon (Si), typically containing 15% to 90% silicon by weight. It is a key additive in the steelmaking and foundry industries due to its deoxidizing properties, ability to improve strength, and resistance to oxidation and corrosion. "/>
        <meta name="keywords" content="Ferrosilicon, alloying additives, Lagos Nigeria" />
		</Helmet>
        <h3>Ferro Silicon</h3>
        <div className='product_wrapper'>
            <div className="image_column">
                <div className="main_image">
                    <img className = 'imgMain' src={img[currentImg]} alt="product_image" />
                </div>
                <div className="slider_image_row">
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[0]} alt="product_image" onClick={(e)=>(setCurrentImg(0))}/>
                    </div>    
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[1]} alt="product_image" onClick={(e)=>(setCurrentImg(1))}/>
                    </div>
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[2]} alt="product_image"  onClick={(e)=>(setCurrentImg(2))} />
                    </div>
                    <div className="slider_image">
                        <img className = 'imgSlide' src={img[3]} alt="product_image"  onClick={(e)=>(setCurrentImg(3))} />
                    </div>
                </div>

            </div>
            <div className="description">
                <p className='text'>
                Key Properties of Our  Ferro Silicon:
                </p>
                <ul>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Strong Deoxidizing Agent
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Increases Strength and Hardness of Steel
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Non-Corrosive and Non-Magnetic
                    </li>
                    <li>
                    <span className="checkCircle"><FontAwesomeIcon icon={faCheckCircle}/></span>Improves Heat Resistance of Steel
                    </li>
                </ul>
                <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAP">Chat Us to Buy</button></a>
            </div>
        </div>
        <div className="details">
        Ferro silicon is an alloy made primarily of iron (Fe) and silicon (Si), typically containing 15% to 90% silicon by weight. It is a key additive in the steelmaking and foundry industries due to its deoxidizing properties, ability to improve strength, and resistance to oxidation and corrosion. Ferro silicon also plays a critical role in the production of silicon steel for transformer cores, electrical motors, and other electromagnetically sensitive components.
        </div>
    </div>
  )
}
